import React, { useState, useRef } from "react";
import { Redirect, useHistory, useLocation } from 'react-router-dom';

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Container, Card, Col, Row, Button, Form, Image} from 'react-bootstrap'
import BackgroundSlider from 'react-background-slider'
import queryString from 'query-string'

import { confirmEmail } from "../actions/auth-action";

import img1 from '../images/bridg/login-bg-1.jpg'
import img2 from '../images/bridg/login-bg-2.jpg'
import img3 from '../images/bridg/login-bg-3.jpg'
import sg3 from "../images/sg3plus.png"
import AuthVerify from "../components/AuthVerify";
import { __WhiteEmailDomainList } from "../common/Dictionaries";


  const ConfirmEmail = (props) => {
    
    const { t } = useTranslation();

    const history = useHistory();
    const { user: currentAuth } = useSelector((state) => state.auth);

    const form = useRef();
    const checkBtn = useRef();

    const { search } = useLocation();
    const values = queryString.parse(search);
    const token = values.token;

    const [email, setEmail] = useState("");
    const [emailConfirmation, setEmailConfirmation] = useState("");

    const [isInvalidEmail, setIsInvalidEmail] = useState(false);
    const [isInvalidEmailConfirmation, setIsInvalidEmailConfirmation] = useState(false);

    const [emailMessageError, setEmailMessageError] = useState("");
    const [emailConfirmationMessageError, setEmailConfirmationMessageError] = useState("");

    const [loading, setLoading] = useState(false);
    const [successful, setSuccessful] = useState(null);

    const { message } = useSelector(state => state.message);

    
    const dispatch = useDispatch();

  

    const isValidEmail = (email, emailConfirmation) => {
      let emailShemaValid = true;
      let emailConfirmationShemaValid = true;

      const hasEspecialEmail = __WhiteEmailDomainList.some(elemento => email.includes(elemento));
      if (email !== "") {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(email) === false && !hasEspecialEmail) {
        //if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(email) === false) {
          emailShemaValid = false;
          setEmailMessageError(t('data-lang-msg-invalid-email'));
          setIsInvalidEmail(true);
        }
      }
      else {
        setEmailMessageError(t('data-lang-msg-required-email'));
        setIsInvalidEmail(true);
      }
  
      const hasEspecialEmailConfirmation = __WhiteEmailDomainList.some(elemento => emailConfirmation.includes(elemento));
      if (emailConfirmation !== "") {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(emailConfirmation) === false && !hasEspecialEmailConfirmation) {
        //if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(emailConfirmation) === false) {
          emailConfirmationShemaValid = false;
          setEmailConfirmationMessageError(t('data-lang-msg-invalid-email'));
          setIsInvalidEmailConfirmation(true);
        }
      }
      else {
        setEmailConfirmationMessageError(t('data-lang-msg-required-emailconfirmation'));
        setIsInvalidEmailConfirmation(true);
      }
  
      if (emailConfirmationShemaValid && emailShemaValid) {
        if (email !== emailConfirmation) {
          setEmailMessageError('');
          setEmailConfirmationMessageError(t('data-lang-msg-notsame-emailandconfirmation'));
          setIsInvalidEmail(false);
          setIsInvalidEmailConfirmation(true);
        return (true)
        }
        else {
          return (false)
        }
      }
      else {
        return (true)
      }
    }
   
    const onChangeEmail = (e) => {
      const email = e.target.value;
      setIsInvalidEmail(email === "");
      setEmail(email);
    };
    
    const onChangeEmailConfirmation = (e) => {
      const emailConfirmation = e.target.value;
      setEmailConfirmation(emailConfirmation);
    };

    const handleConfirmEmail = (e) => {
      e.preventDefault();
      
      setSuccessful(null);
      setLoading(true);
         
      let _isInvalidEmail = isValidEmail(email, emailConfirmation);
      
      if (!_isInvalidEmail) {

        let languaje = localStorage.getItem("i18nextLng");

        dispatch(confirmEmail(token, email, languaje)).then(() => {          
            setSuccessful(true);
        }).catch(() => {
          setLoading(false);
          setSuccessful(false);
        });

      } else {
        setLoading(false);
      }
    };
    
    return (
        <>     
          <AuthVerify currentToken={currentAuth} />
          <BackgroundSlider
            images={[img1, img2, img3]}
            duration={10} transition={2} />

          <Container style={{marginTop: "300px"}} className="col-xl-5 login-bg">
            <Card className="cardforgot-container">
              <div className="profile-img-card">
                <Image
                  src={sg3}
                  alt="profile-img"
                />
              </div>
              <Form ref={form}>
                <fieldset >
                  {successful === null  && (
                    <>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label htmlFor="email">{t('data-lang-lbl-email')}</Form.Label>
                              <Form.Control
                                id="txtEmail"
                                name="email"
                                type="text"
                                className="form-control"
                                value={email}
                                onChange={onChangeEmail}
                                isInvalid={isInvalidEmail !== null ? isInvalidEmail : false}
                                autoComplete="off"
                                placeholder="" required={true} /> 
                                {
                                  isInvalidEmail === true &&
                                  <div className="invalid-feedback">
                                    {emailMessageError}
                                  </div>
                                } 
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group className="mb-3">
                      <Row>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="emailconfirmation">{t('data-lang-lbl-emailconfirmation')}</Form.Label>
                            <Form.Control
                              id="txtEmailConfirmation"
                              name="emailConfirmation"
                              type="text"
                              className="form-control"
                              value={emailConfirmation}
                              onChange={onChangeEmailConfirmation}
                              isInvalid={isInvalidEmailConfirmation !== null ? isInvalidEmailConfirmation : false}
                              autoComplete="off"
                              placeholder="" required={true} /> 
                              {
                                isInvalidEmailConfirmation === true &&
                                <div className="invalid-feedback">
                                  {emailConfirmationMessageError}
                                </div>
                              }  
                          </Form.Group>
                        </Col>
                      </Row>
                      </Form.Group>
                    </>
                  )}
                  {successful !== null && (
                    <div className="form-group">
                      <div className={ successful ? "alert alert-success" : "alert alert-danger" } role="alert">
                        {t(message)}
                      </div>
                    </div>
                  )}
                  <Form.Group className="mb-3 text-end">
                    <Row className="mb-3 text-end row justify-content-end">
                      <Button onClick={history.goBack} className="col-3 m-2 btn btn-primary btn-block btn btn-primary">
                        <span> {t('data-lang-btn-goback')} </span>
                      </Button>
                      {successful === null  && (
                        <Button onClick={handleConfirmEmail} className="col-5 m-2 btn btn-primary btn-block btn btn-primary" disabled={loading} >
                          {loading && (
                            <span className="spinner-border spinner-border-sm"></span>
                          )}
                          <span> {t('data-lang-btn-confirmemail')} </span>
                        </Button>
                      )}
                    </Row>
                  </Form.Group>
                  <Form.Check style={{ display: "none" }} ref={checkBtn} />
                </fieldset>
              </Form>
            </Card>
          </Container>
          </>
      );
  };
    
  export default ConfirmEmail;
    